import { render, staticRenderFns } from "./StickyMenuLanguage.vue?vue&type=template&id=2ffc3185&"
import script from "./StickyMenuLanguage.vue?vue&type=script&lang=js&"
export * from "./StickyMenuLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports